import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoNivelIdiomasDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoNivelIdiomasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoNivelIdiomasService(): Observable<BodyListResponse<CatalogoNivelIdiomasDTO>> {
    return this.http.get<BodyListResponse<CatalogoNivelIdiomasDTO>>(API_URL + '/api/v1/catalogoNivelIdiomas/todos');
  }

  guardarCatalogoNivelIdiomasService(catalogoNivelIdiomasDTO: CatalogoNivelIdiomasDTO): Observable<CatalogoNivelIdiomasDTO> {
    return this.http.post<CatalogoNivelIdiomasDTO>(API_URL + '/api/v1/catalogoNivelIdiomas', catalogoNivelIdiomasDTO);
  }

  getCatalogoNivelIdiomasPorCodigoCatalogoNivelIdiomasService(codigoCatalogoNivelIdiomas: string): Observable<BodyResponse<CatalogoNivelIdiomasDTO>> {
    return this.http.get<BodyResponse<CatalogoNivelIdiomasDTO>>(API_URL + '/api/v1/catalogoNivelIdiomas/' + codigoCatalogoNivelIdiomas);
  }
}
